import { createApp } from 'vue';
import ItineraryOverviewApp from './ItineraryOverviewApp.vue';
import { i18n } from '../../i18n';

// The modal's copy is all `$t`, so the app must install i18n — without it the
// first render throws and the hike page's "Itinerary" menu item does nothing.
export function createItineraryOverviewApp() {
  const app = createApp(ItineraryOverviewApp);
  app.use(i18n);
  return app;
}

// Only mounts when the mount point is present on the page.
const el = document.getElementById('itinerary-overview-app');
if (el) {
  createItineraryOverviewApp().mount(el);
}
